import * as types from "./SelectedMembersForConfirmationType";

export function addMember(member) {
    return {
        type: types.ADD_MEMBER,
        member: member,
    };
}

export function removeMember(member) {
    return {
        type: types.REMOVE_MEMBER,
        member: member,
    };
}

export function clearMembers() {
    return {
        type: types.CLEAR_MEMBERS,
    };
}



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/members/SelectedMembersForConfirmationActions.js